<div class="card mb-4">
  <div class="card-body">

    <h4 class="mb-4 fw-bolder">Printing Records</h4>

    <!-- Filters -->
    <div class="row mb-4">

      <div class="col-md-2">
        <label>Operator</label>
        <select
          class="form-control"
          [(ngModel)]="searchOperator"
          (ngModelChange)="filterTable()">

          <option value="">All Operators</option>

          <option *ngFor="let op of operatorNames" [value]="op">
            {{ op }}
          </option>

        </select>
      </div>

      <div class="col-md-2">
        <label>Shift</label>
        <input
          type="text"
          class="form-control"
          list="shiftList"
          [(ngModel)]="searchShift"
          (input)="filterTable()">

        <datalist id="shiftList">
          <option *ngFor="let shift of shiftNames" [value]="shift"></option>
        </datalist>
      </div>

      <div class="col-md-2">
        <label>Machine</label>
        <input
          type="text"
          class="form-control"
          list="machineList"
          [(ngModel)]="searchMachine"
          (input)="filterTable()">

        <datalist id="machineList">
          <option *ngFor="let machine of machineNames" [value]="machine"></option>
        </datalist>
      </div>

      <div class="col-md-2">
        <label>Client</label>
        <input
          type="text"
          class="form-control"
          list="clientList"
          [(ngModel)]="searchClient"
          (input)="filterTable()">

        <datalist id="clientList">
          <option *ngFor="let client of clientNames" [value]="client"></option>
        </datalist>
      </div>

      <div class="col-md-2">
        <label>Job Name</label>
        <input
          type="text"
          class="form-control"
          list="jobList"
          [(ngModel)]="searchJobName"
          (input)="filterTable()">

        <datalist id="jobList">
          <option *ngFor="let job of jobNames" [value]="job"></option>
        </datalist>
      </div>

      <div class="col-md-2">
        <label>Ticket No</label>
        <input
          type="text"
          class="form-control"
          list="ticketList"
          [(ngModel)]="searchTicket"
          (input)="filterTable()">

        <datalist id="ticketList">
          <option *ngFor="let ticket of ticketNumbers" [value]="ticket"></option>
        </datalist>
      </div>

    </div>

    <div class="row mb-4">

      <div class="col-md-2">
        <label>Ref No</label>
        <input
          type="text"
          class="form-control"
          list="refList"
          [(ngModel)]="searchRefNo"
          (input)="filterTable()">

        <datalist id="refList">
          <option *ngFor="let ref of refNumbers" [value]="ref"></option>
        </datalist>
      </div>

      <div class="col-md-2">
        <label>From Date</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="searchFromDate"
          (input)="filterTable()">
      </div>

      <div class="col-md-2">
        <label>To Date</label>
        <input
          type="date"
          class="form-control"
          [(ngModel)]="searchToDate"
          (input)="filterTable()">
      </div>

      <div class="col-md-2 mt-4">
        <button
          class="btn btn-danger"
          (click)="clearFilters()">
          Clear Filters
        </button>
      </div>

      <div class="col-md-2 mt-4">
        <button
          class="btn btn-success"
          (click)="exportToExcel()">
          Export Excel
        </button>
      </div>

    </div>

    <div class="table-responsive">

      <table
        *ngIf="paginatedTempPrintingData.length > 0"
        class="table table-bordered text-center">

        <thead>
          <tr>
            <th>Ticket No</th>
            <th>Job Name</th>
            <th>Date</th>
            <th>Ref No</th>
            <th>PO Number</th>
            <th>Client Name</th>
            <th>Operator</th>
            <th>Shift</th>
            <th>JCO</th>
            <th>Machine</th>
            <th>Used Size</th>
            <th>Input</th>
            <th>Output</th>
            <th>Material</th>
            <th>Thickness</th>
            <th>Width</th>
            <th>Wastage</th>
            <th>Consumed</th>
            <th>Total Sol</th>
            <th>Extra</th>
          </tr>
        </thead>

        <tbody>

          <tr *ngFor="let entry of paginatedTempPrintingData">

            <td>{{ entry.ticketNo }}</td>
            <td>{{ entry.jobName }}</td>
            <td>{{ entry.date }}</td>
            <td>{{ entry.refNo }}</td>
            <td>{{ entry.poNumber }}</td>
            <td>{{ entry.clientName }}</td>
            <td>{{ entry.operator }}</td>
            <td>{{ entry.shift }}</td>
            <td>{{ entry.jco }}</td>
            <td>{{ entry.machine }}</td>
            <td>{{ entry.usedSize }}</td>
            <td>{{ entry.input }}</td>
            <td>{{ entry.output }}</td>
            <td>{{ entry.material }}</td>
            <td>{{ entry.thickness }}</td>
            <td>{{ entry.width }}</td>
            <td>{{ entry.wastage }}</td>
            <td>{{ entry.consumed }}</td>
            <td>{{ entry.totalSol }}</td>
            <td>{{ entry.extra }}</td>

          </tr>

        </tbody>

        <tfoot>
          <tr>

            <td colspan="10"><strong>Total</strong></td>

            <td><strong>{{ getTotal('usedSize') | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotal('input') | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotal('output') | number:'1.2-2' }}</strong></td>

            <td></td>

            <td><strong>{{ getTotal('thickness') | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotal('width') | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotal('wastage') | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotal('consumed') | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotal('totalSol') | number:'1.2-2' }}</strong></td>
            <td><strong>{{ getTotal('extra') | number:'1.2-2' }}</strong></td>

          </tr>
        </tfoot>

      </table>

      <div *ngIf="paginatedTempPrintingData.length === 0">
        No data available.
      </div>

    </div>

  </div>
</div>